module.exports = __webpack_public_path__ + "img/coinbankB00.41b07140.jpg";